export default "__VITE_ASSET__Bo$2q7ie__"